import { render, staticRenderFns } from "./motivoConsulta.vue?vue&type=template&id=042f4503"
import script from "./motivoConsulta.vue?vue&type=script&lang=js"
export * from "./motivoConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports